import React, { useState, useEffect } from 'react';
import { message, Table } from 'components/shared/AntComponent';
import { ApexOptions } from 'apexcharts';
import Chart from 'react-apexcharts';
import YellowGirlImg from 'assets/img/yellow-girl-removebg-prev.png';
import InterviewIcon from 'assets/icons/interview-user.svg';
import GraduateIcon from 'assets/icons/graduate-icon.svg';
import InternIcon from 'assets/icons/internship-icons.svg';
import InternBatchIcon from 'assets/icons/intern-batch-icon.svg';
import InternProjIcon from 'assets/icons/intern-project-icon.svg';
import { EyeIcon } from 'assets/icons/CustomIcons';
import CopyIcon from 'assets/icons/copy.svg';
import { useDispatch } from 'react-redux';
import { getCandidDashboard, getDashboardInfo } from 'services/store/actions/dashboardAction';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';

const dataSource = [
    {
        key: '1',
        test_name: 'Aptitude Test',
        candidate_name: 'Nisha M',
        test_category: 'APT',
        subjects: 'General Knowledge',
        email: "trest_1@1gmail.com",
        examDate: '20-05-2025',
        scored_marks: '30'
    },
    {
        key: '2',
        test_name: 'Aptitude Test',
        candidate_name: 'Pooja J',
        test_category: 'APT',
        subjects: 'General Knowledge',
        email: 'selvaraj@akash.com',
        examDate: '20-05-2025',
        scored_marks: '25'
    },
    {
        key: '3',
        test_name: 'Aptitude Test',
        candidate_name: 'Krishna Kumar',
        test_category: 'APT',
        subjects: 'General Knowledge',
        email: "sd2@gmail.co",
        examDate: '20-05-2025',
        scored_marks: '20'
    },
    {
        key: '4',
        test_name: 'Aptitude Test',
        candidate_name: 'Sanjeev Rajan',
        test_category: 'APT',
        subjects: 'General Knowledge',
        email: 'udhayakumar2352001@gmail.com',
        examDate: '20-05-2025',
        scored_marks: '10'
    },
    {
        key: '5',
        test_name: 'Aptitude Test',
        candidate_name: 'Mohana Priya S',
        test_category: 'APT',
        subjects: 'General Knowledge',
        email: 'udhayakumar2352001@gmail.com',
        examDate: '20-05-2025',
        scored_marks: '07'
    },
];

const columns = [
    {
        title: 'Candidate Name',
        dataIndex: 'candidate_name',
        key: 'candidate_name',
    },
    {
        title: 'Exam Name',
        dataIndex: 'test_name',
        key: 'test_name',
    },
    {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
    },
    {
        title: 'Exam Date',
        dataIndex: 'examDate',
        key: 'examDate',
    },
    {
        title: 'Secured Marks',
        dataIndex: 'scored_marks',
        key: 'scored_marks',
    },
    {
        title: 'Actions',
        dataIndex: 'actions',
        key: 'actions',
        // align:'center',
        render: (_: any, record: any) => {
            return (
                <div className="d-flex w-100">
                    {/* <div className="text-warning pointer eye-icon my-auto py-1" onClick={() => viewDetails(record)}>
                        <EyeIcon size={20} />
                    </div> */}
                </div>
            );
        },
    },
];

const KosoftDashboard: React.FC = () => {
    const dispatch = useDispatch();
    const { dashInfo, loading2, loading, dashCandidInfo, loading1, dashboardInfo } = useSelector((state: any) => state.dashboard);
    const { examData, loading: examLoading, success8, error8 } = useSelector((state: any) => state.exam);
    const examList = dashboardInfo?.upcoming_exams || [];
    const examCount = dashboardInfo?.monthly_exam_report?.exam_counts.filter((value: any) => value !== 0)?.length;
    const [exam, setExam] = useState('');
    const url = window.origin;
    const urlValue = `${url}/candidate-registration-form`;
   
    const handleCopyUrl = () => {
        navigator.clipboard.writeText(urlValue);
        message.success("Url copied successfully");
    }

    const series = [{
        name: "Exam",
        data: dashboardInfo?.monthly_exam_report?.exam_counts || []
    }];

    const options: ApexOptions = {
        colors: ["#F7941E"],
        chart: {
            height: 350,
            type: 'bar',

            toolbar: {
                show: false,
            },
            zoom: {
                enabled: false // Disable zooming
            },
        },

        dataLabels: {
            enabled: false
        },
        stroke: {
            width: 1.5,
            curve: 'smooth',

        },
        title: {
            text: '',
            align: 'left'
        },
        grid: {
            show: false,
            xaxis: {
                lines: {
                    show: false  //or just here to disable only x axis grids
                }
            },
            // row: {
            //     colors: ['#fff'], // takes an array which will be repeated on columns
            //     opacity: 0.5
            // },
        },
        yaxis: {
            labels: {
                show: false,
            },
        },
        xaxis: {
            labels: {
                show: false,
            },
            // axisBorder: {
            //     show: false
            // },
            categories: dashboardInfo?.monthly_exam_report?.months || [],
        }
    };
  
    const series1 = [{
        name: 'General Intern',
        type: 'line',
        data: dashCandidInfo?.data?.candidates_analysis?.intern_candidates||[]
    }, {
        name: 'Project Intern',
        type: 'area',
        data: dashCandidInfo?.data?.candidates_analysis?.project_candidates||[]
    },
    {
        name: 'Interviewee',
        type: 'area',
        data: dashCandidInfo?.data?.candidates_analysis?.interview_candidates||[]
    },];
      const options1: ApexOptions = {
            // colors: ["#696cff", "#03c3ec","#67dbf3"],
            // colors: ["#ffa50094", "#acec85", "#696cffad",],
            chart: {
                type: 'line',
                height: 350,
                toolbar: {
                    show: false,
                },
                zoom: {
                    enabled: false // Disable zooming
                },
            },
    
            legend: {
                show: true,
                position: 'top',
                // t: 'right',
                horizontalAlign: 'right',
                fontFamily: 'Lato',
                // markers: {
                //     width: 15,
                //     height: 3,
                // },
            },
            dataLabels: {
                enabled: false,
            },
            stroke: {
                curve: 'smooth',
                width: 2,
            },
            grid: {
                show: false,
                xaxis: {
                    lines: {
                        show: false  //or just here to disable only x axis grids
                    }
                },
            },
            colors: ['#ffa902', '#7a6efe', '#24a8fa'],
            xaxis: {
                // type: 'date',
                tickAmount: 4,
                categories: dashCandidInfo?.data?.candidates_analysis?.dates || [],
                labels: {
                    rotate: 0,  // Remove rotation by setting it to 0
                },
            },
    
            tooltip: {
                x: {
                    format: 'MM/dd/yy ',
                    // max: 4,
                },
            },
        };
    const statItems = [
        { id: 1, cardName: 'Interviewee Count', value: dashCandidInfo?.data?.interview_candidate_count || 232, color: 'stat-green', icon: InterviewIcon, year: '' },
        { id: 2, cardName: 'Project Intern Count', value: dashCandidInfo?.data?.project_candidate_count || 323, color: 'stat-blue', icon: GraduateIcon, year: '' },
        { id: 3, cardName: 'General Intern Count', value: dashCandidInfo?.data?.intern_candidate_count || 123, color: 'stat-red', icon: InternIcon, year: '' },
        { id: 4, cardName: 'Batch Count', value: dashCandidInfo?.data?.project_count + dashCandidInfo?.data?.batch_count || 14, color: 'stat-purple', icon: InternBatchIcon, year: '' },
        { id: 5, cardName: 'Exam Report', value: examCount, color: 'stat-orange', icon: InternProjIcon, year: dashboardInfo?.year||'2025' }
    ];
    useEffect(() => {
        dispatch(getCandidDashboard() as any);
    }, []);

    useEffect(() => {
        dispatch(getDashboardInfo() as any);
    }, []);

    return (
        <div>
            <div className="row mx-0 mt-2 dash-row ">
                <div className="col-md-8 px-0 dash-left-card">
                    <div className='bg-white rounded shadow-sm ms-1'>
                        <div className='d-flex my-auto'>
                            <div className='p-3 my-auto'>
                                <h4 className='text-primary fw-bold'>Welcome {localStorage?.getItem('firstname')}! <span className='fs-18 ps-2'>🎉</span></h4>
                                <p className='mt-3 fs-15 mb-0 text-gray'>We’re glad to have you on the dashboard. </p>
                                <p className='text-gray fs-15 mb-0'>Manage candidate assessments, track progress, and streamline your hiring process—all from one place.</p>
                                <div>
                                    <div className="text-blue text-decoration-underline fw-bold mt-2 pointer" onClick={handleCopyUrl}><img src={CopyIcon} height="18" className='pointer pe-1' />Copy public form url</div>
                                </div>
                                {/* <Button type='default' className='mt-3 bg-transparent text-blue' onClick={handleCopyUrl}>Copy public form link</Button> */}
                            </div>
                            <div className='col-md-3 ms-auto mt-auto'>
                                <img src={YellowGirlImg} alt="pink girl" height={160}></img>
                            </div>
                        </div>
                    </div>
                    <div className='bg-white p-3 mt-3 ms-1 rounded shadow-sm'>
                        <h5 className='text-secondary regular-font'>Candidates Analysis</h5>
                        <Chart options={options1} series={series1} type="area" width="100%" height="275vh" />
                    </div>
                    <div className='bg-white p-3 mt-3 ms-1 rounded shadow-sm custom-table dashboard-table'>
                        <h5 className='regular-font text-secondary'>Exam Result</h5>
                        <Table dataSource={dataSource} columns={columns} rowKey="id" className='border' />
                    </div>
                </div>
                <div className="col-md-4 px-0 h-100 dash-right-card">
                    <div className="stat-cards-box me-1 row mx-0">
                        {statItems?.map((item: any, index: number) => {
                            return (
                                <div key={index} className={`stat-card ${item.color} rounded ${item.id == 5 ? 'col' : 'col-md-6'} pe-0`}>
                                    {item.id !== 5 ? <div className='bg-white rounded shadow-sm p-2 mb-3'>
                                        <div className={`bg-img ms-2 mt-2`}>
                                            <img src={`${item.icon}`} height={item.id == 3 || item.id == 4 || item.id == 5 ? 30 : 33} />
                                        </div>
                                        <div className=" mb-0 ps-2 mt-3 text-gray fs-16 ">{item.cardName}</div>
                                        <div className='text-darkgray regular-font ps-2 fs-3 mb-2 mt-2'>{item.value}</div>
                                    </div> :
                                        <div className='bg-white rounded shadow-sm  mb-3 d-flex'>
                                            <div className='ps-3 pt-3 col-md-4'>
                                                <h5 className='text-secondary regular-font'>Exam Report</h5>
                                                <p className='bg-orange mb-2 mt-4 ps-0'>YEAR {item.year}</p>
                                                <div className='text-darkgray regular-font ps-0 fs-2 '>{examCount}</div>
                                            </div>
                                            <div className='ms-auto col'>
                                                <Chart options={options} series={series} type="bar" width="100%" height="160vh" />
                                            </div>
                                        </div>
                                    }
                                </div>
                            )
                        })}
                    </div>
                    <div className='mx-0 px-1 pt-0'>
                        <div className='bg-white p-3 rounded shadow-sm ms-2'>
                            <div className='d-flex mb-3'>
                                <h5 className='regular-font text-secondary'>Upcoming Exam</h5>
                                <div className='ms-auto col-auto'>
                                    <p className='text-blue mb-0 regular-font pointer'>See all</p>
                                </div>
                            </div>
                            <div className='control-height'>
                                {examList?.map((item: any, index: any) => {
                                    return (
                                        <div key={index} className='bg-lightblue  mb-3 p-3'>
                                            <div className="d-flex">
                                                <h6 className='regular-font'>{item.exam_title}</h6>
                                                <h6 className='ms-auto regular-font'>{item.examcode}</h6>
                                            </div>
                                            <p className='text-gray mb-1'>{item.description}</p>
                                            <small className='text-gray fs-13 fw-600'>Date: {item?.exam_date ? dayjs(new Date(item?.exam_date)).format('MM/DD/YYYY') : '--'}</small>
                                            <small className='text-gray fs-13 fw-600 ps-5'>{item.start_time}</small>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default KosoftDashboard;
